import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { GuestRFQParams, GuestRFQService } from "@WhiteCap/Services/GuestRFQService";
import { purchase } from "@WhiteCap/Common/Utillities/CustomTracking";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";


{/* EC-235 = Handler to handle the Guest RFQ form Submission */}

// Define the handler type with API parameters and response structure
// type HandlerType = CustomApiHandler<GuestRFQParams & HasOnSuccess, { successful: boolean; result?: { quoteNumber: any }; }>

export interface GTMCartItem {
    ProductID: string;
    Title: string;
    Brand: string;
    Quantity: number;
}

type GuestRFQParamsWithCart = GuestRFQParams & HasOnSuccess & {
    gtmCart?: GTMCartItem[];
};

type HandlerType = CustomApiHandler<GuestRFQParamsWithCart, { 
    successful: boolean; 
    result?: { quoteNumber: any }; 
}>;


// Step 1: Begin API call service
// This function dispatches an action to indicate that the API call process has started.
export const BeginApiCallService: HandlerType = props => {
	props.dispatch({
		type: "Custom/GuestRFQ/BeginApiCallService",
	});
};

// Step 2: Load API call service
// This function makes an API call using the provided GuestRFQService and passes the form data.
// If an error occurs during the API call, it is logged in the console.
export const LoadApiCallService: HandlerType = async (props) => {
	const formData = props.parameter;

	try {
		props.apiResult = await GuestRFQService({
			...formData,
		})
		
	} catch (error) {
		console.error('Error submitting quote:', error);
	}
};

// Step 3: Execute on-success callback
// If the API call is successful, this function executes the `onSuccess` callback provided in the parameters.
export const ExecuteOnSuccessCallback: HandlerType = props => {
	if (props.apiResult.successful && props.apiResult.result) {
        const quoteNumber = props.apiResult.result.quoteNumber;
        props.parameter.onSuccess?.(quoteNumber); // Pass `quoteNumber` to the callback
    }
};


export const SendPurchaseEvent: HandlerType = props => {
	const session = getSession(props.getState());
    if (props.apiResult.successful && props.apiResult.result && props.parameter.gtmCart?.length) {
        const itemData = props.parameter.gtmCart.map(item => ({
            item_id: item.ProductID,
            item_name: item.Title,
            item_brand: item.Brand,
            price: 0,
            quantity: item.Quantity,
        }));

        const data = {
            event: "purchase",
            ecommerce: {
                transaction_id: props.apiResult.result.quoteNumber ?? "",
                currency: session?.currency?.currencyCode,
                value: 0,
                items: itemData,
            },
        };

        purchase(data);
    }
};



// Step 4: Complete API call service
// This function dispatches an action to indicate that the API call process has completed.
export const CompleteLoadApiCallService: HandlerType = props => {
	props.dispatch({
		type: "Custom/GuestRFQ/CompleteLoadApiCallService",
	});
};


// Define the chain of handlers to execute in sequence
export const chain = [BeginApiCallService, LoadApiCallService, ExecuteOnSuccessCallback, SendPurchaseEvent, CompleteLoadApiCallService];

// Create and export the handler chain runner with the chain defined above
const GuestRFQApiHandler = createHandlerChainRunner(chain, "GuestRFQApiHandler");
export default GuestRFQApiHandler;

{/* EC-235 = Handler to handle the Guest RFQ form Submission */}
